import * as yup from 'yup';

export const personalInfoValidation = yup.object().shape({
    firstname: yup.string().required(),
    lastname: yup.string().required(),
    othername: yup.string().notRequired(),
    dateOfBirth: yup.string().required(),
    religion: yup.string().required(),
});


export const vocationInfoValidation = yup.object().shape({
    education: yup.string().required(),
    occupation: yup.string().notRequired(),
    empoymentStatus: yup.string(),
    averageIncome: yup.string().required()
});

export const contactInfoValidation = yup.object().shape({
    phone: yup.string().required(),
    country: yup.string().required(),
    state: yup.string().notRequired(),
    // averageIncome: yup.string().required()
});